import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Text } from '@olist/united';

export const TextLink = styled(Text.Link).attrs({
  color: 'foundation.shadeDarker',
  colorHover: 'foundation.shadeDark',
  weight: 'bold',
  target: '_blank',
})`
  &:not(:hover) {
    &:visited {
      color: ${themeGet('colors.foundation.shadeDarker')};
    }
  }
`;
